import { useTranslation } from 'react-i18next';
import { de, enUS } from 'date-fns/locale';

export function useDateLocale() {
  const { i18n } = useTranslation();
  return i18n.language.startsWith('en') ? enUS : de;
}
